/* eslint-disable no-unused-vars */
import React from 'react';
import { KeyboardBackspace } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { Box, styled } from '@mui/system';
import { Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import FormikErrorFocus from 'formik-error-focus';

import { AuthSubtitle, AuthTitle } from '../index.styles';
import AuthInput from '../../../../features/auth/components/authInput';
import AuthButton from '../../../../features/auth/components/authSubmitButton';
import { FieldType, IModalData } from '../../../../shared/utilities/interfaces';
import { getValidation } from '../../../../shared/utilities/validationSchema';
import { connect } from 'react-redux';
import { resetPasswordAction } from 'features/auth/store/actions';
import { enableModal } from 'core/store/app/actions';
import { ResetPasswordFormBody } from 'features/auth/utilites';

interface IResetPassword {
  enableAppModal: (data: IModalData) => void;
  resetPassword: (data: ResetPasswordFormBody) => void;
};

const BackBtn = styled(IconButton)(({ theme }) => {
  return {
    position: 'absolute',
    top: '-15%',
    left: '-30%',
    [theme.breakpoints.down(1025)]: {
      top: '-18%',
      left: '-13%'
    },
    [theme.breakpoints.down(395)]: {
      top: '-16%',
      left: '-13%'
    },
  };
});

const ResetPasswordFields: FieldType[] = [
  {
    field: 'email',
    label: 'Email',
    type: 'text',
    validation: {
      type: 'email',
      length: {
        max: 40,
        min: 0
      },
      required: true
    }
  }
];

const resetPasswordSchemaValidation = () => {
  const resetPasswordSchema = {
    email: Yup
      .string()
      .strict(true)
      .trim('Email should not include trailing white spaces')
      .email("You have entered incorrect email address")
      .required('This field is required'),
  };
  return Yup.object().shape(resetPasswordSchema);
};

function ResetPassword(resetPasswordProps: IResetPassword) {
  const {
    resetPassword
  } = resetPasswordProps;

  const initialValues = {
    email: ''
  };

  const handleSubmit = (data: typeof initialValues) => {
    // call api for login
    // enableAppModal({
    //   alertTitle: 'Error',
    //   message: 'this is an error',
    //   severity: 'error',
    //   strongText: 'see here'
    // });
    resetPassword({
      email: data.email
    });
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <BackBtn onClick={() => history.back()}>
        <KeyboardBackspace sx={{
          color: 'common.black'
        }} />
      </BackBtn>
      <AuthTitle variant='h4' fontWeight="bold">
        Reset Password
      </AuthTitle>
      <AuthSubtitle
        variant='body1'
      >
        Enter your email. Once you click submit,
        you will receive a link to this email which
        will allow you to update your password.
      </AuthSubtitle>
      <Formik
        initialValues={initialValues}
        validationSchema={resetPasswordSchemaValidation()}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnBlur
      >
        {({ handleSubmit }: FormikProps<typeof initialValues>) =>
        (
          <form
            onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
          <AuthInput
            variant='standard'
            label='Email'
            name='email'
            autoFocus
          />
            <AuthButton
              variant="contained"
              type='submit'
            >
              Submit
            </AuthButton>
            <FormikErrorFocus
              offset={0}
              align="middle"
              focusDelay={10}
              ease="linear"
              duration={500}
            />
          </form>
        )}
      </Formik>
    </Box>
  );
}

export default connect(
  null,
  ({
    enableAppModal: enableModal,
    resetPassword: resetPasswordAction
  })
)(ResetPassword);;